export default __webpack_public_path__ + "static/media/tpa-linkedin.90a191ec.png";